import { cn } from '@/utils/ui/styles'

import { KPI_CARD_HEIGHT_CLASS } from '../common/kpi-card'
import { Skeleton } from '../ui/skeleton'

/**
 * The xl column count per strip size. Tailwind cannot take an interpolated
 * class, and these are the only three strip widths the app ships — the key
 * type is what keeps that claim true. `2` needs no `xl:` override: the base
 * `sm:grid-cols-2` already fits two cards at every width above it.
 */
const STRIP_COLUMNS: Record<2 | 3 | 4, string> = {
	2: '',
	3: 'xl:grid-cols-3',
	4: 'xl:grid-cols-4',
}

type KpiStripSkeletonProps = {
	count: 2 | 3 | 4
}

/**
 * A KPI strip's loading shape: `count` cards' worth of grey, in the strip's own
 * grid.
 *
 * A whole-card placeholder rather than a card with its label rendered for real
 * (P-05 §1), and the exception is deliberate: every strip in the app loads this
 * way, the block is exactly the resolved card's height, and nothing below it
 * moves when the numbers land. Rendering labels on one strip only would make
 * that page the odd one out for no gain.
 */
export const KpiStripSkeleton = ({ count }: KpiStripSkeletonProps) => {
	return (
		<div
			className={cn(
				'grid grid-cols-1 gap-4 sm:grid-cols-2',
				STRIP_COLUMNS[count],
			)}
		>
			{Array.from({ length: count }).map((_, index) => (
				<Skeleton key={index} className={cn(KPI_CARD_HEIGHT_CLASS, 'w-full')} />
			))}
		</div>
	)
}
